import React from 'react';
import { useTranslation } from 'react-i18next';
import { ServiceLocation } from '../../../types';
import InfoTooltip from '../../InfoTooltip/InfoTooltip';
import './ServiceLocationSection.css';

interface ServiceLocationSectionProps {
  serviceLocation?: ServiceLocation;
  onChange: (sl: ServiceLocation) => void;
  editable: boolean;
  title?: string;
}

export const ServiceLocationSection: React.FC<ServiceLocationSectionProps> = ({
  serviceLocation,
  onChange,
  editable,
  title,
}) => {
  const { t } = useTranslation();

  const update = (field: keyof ServiceLocation, value: string) => {
    onChange({ ...serviceLocation, [field]: value || undefined });
  };

  return (
    <section className="sidebar-section service-location-section">
      <div className="sidebar-header">
        <h3>{title || t('reportForm.serviceLocation')}</h3>
        <div className="service-location-header-right">
          <span className="service-location-optional">{t('common.optional')}</span>
          <InfoTooltip
            text={
              <div>
                <p style={{ margin: '0 0 6px 0', fontWeight: 'bold' }}>{t('reportForm.serviceLocationTooltipTitle')}</p>
                <p style={{ margin: 0 }}>{t('reportForm.serviceLocationTooltipText')}</p>
              </div>
            }
          />
        </div>
      </div>
      <div className="sidebar-grid">
        <div className="form-field">
          <label>{t('reportForm.serviceLocationDescription')}</label>
          <input
            type="text"
            value={serviceLocation?.description || ''}
            placeholder={editable ? 'e.g. Proform GmbH – Munich Branch' : ''}
            onChange={(e) => update('description', e.target.value)}
            disabled={!editable}
            readOnly={!editable}
          />
        </div>
        <div className="form-field">
          <label>{t('reportForm.serviceLocationAddress')}</label>
          <input
            type="text"
            value={serviceLocation?.address || ''}
            placeholder={editable ? 'e.g. Industriestraße 45' : ''}
            onChange={(e) => update('address', e.target.value)}
            disabled={!editable}
            readOnly={!editable}
          />
        </div>
        <div className="service-location-city-country">
          <div className="form-field">
            <label>{t('reportForm.serviceLocationCity')}</label>
            <input
              type="text"
              value={serviceLocation?.city || ''}
              placeholder={editable ? 'e.g. München' : ''}
              onChange={(e) => update('city', e.target.value)}
              disabled={!editable}
              readOnly={!editable}
            />
          </div>
          <div className="form-field">
            <label>{t('reportForm.serviceLocationCountry')}</label>
            <input
              type="text"
              value={serviceLocation?.country || ''}
              placeholder={editable ? 'e.g. DE' : ''}
              onChange={(e) => update('country', e.target.value)}
              disabled={!editable}
              readOnly={!editable}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceLocationSection;
